"use client"

import { RadioGroup, ListItem, ListItemText, Typography, FormControlLabel, Radio, IconButton, Box } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"

export function SelectionList({ items, selected, onSelect, loading, emptyMessage, onEdit, onDelete }) {
  if (loading) {
    return (
      <Typography textAlign="center" sx={{ py: 2 }}>
        در حال بارگذاری...
      </Typography>
    )
  }

  if (items.length === 0) {
    return (
      <Typography textAlign="center" sx={{ py: 2 }}>
        {emptyMessage}
      </Typography>
    )
  }

  return (
    <RadioGroup value={selected} onChange={(e) => onSelect(e.target.value)}>
      {items.map((item) => {
        const isSelected = selected === item.id

        return (
          <ListItem
            key={item.id}
            onClick={() => onSelect(item.id)}
            sx={{
              mb: 1,
              borderRadius: 1,
              border: "2px solid",
              borderColor: isSelected ? "primary.main" : "grey.300",
              bgcolor: isSelected ? "primary.light" : "background.paper",
              "&:hover": {
                cursor: "pointer",
                borderColor: isSelected ? "primary.dark" : "grey.400",
              },
            }}
          >
            <FormControlLabel value={item.id} control={<Radio disableRipple />} label="" sx={{ mr: 0 }} />

            <ListItemText
              primary={
                <Typography variant="body1" color={isSelected ? "white" : "text.primary"}>
                  {item.name}
                </Typography>
              }
            />
            {(onEdit || onDelete) && (
              <Box sx={{ display: "flex", gap: 0.5 }} onClick={(e) => e.stopPropagation()}>
                {onEdit && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onEdit(item);
                    }}
                    sx={{ color: isSelected ? "white" : "text.primary" }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                )}
                {onDelete && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(item.id);
                    }}
                    sx={{ color: isSelected ? "white" : "text.primary" }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            )}
          </ListItem>
        )
      })}
    </RadioGroup>
  )
}
